import { storeToRefs } from 'pinia'

import { useIntercomStore } from '../../stores/intercom/useIntercomStore'

import { useIntercomInvoker } from './useIntercomInvoker'

export const useIntercom = () => {
  const store = useIntercomStore()
  const { isAvailable } = storeToRefs(store)
  const { callIntercomMethod } = useIntercomInvoker()

  return {
    callIntercomMethod,
    init: store.init,
    isAvailable,
    loadIntercomOnDemand: store.loadIntercomOnDemand,
    shutdown: store.shutdown,
  }
}
